module.exports = __webpack_public_path__ + "static/04-f4c89cdf7b3642d6ea28751a11fcfe98.jpg";